import { notify as vueNotify } from "@kyvg/vue3-notification";

export const notify = {
	success(m, title) {
		vueNotify({
			group: "default",
			title: title || "Success",
			type: "success",
			text: m,
		});
	},
	error(m, title) {
		vueNotify({
			group: "default",
			title: title || "Error",
			type: "error",
			text: m || "There has been an error",
		});
	},
};
